<table [id]="tableId" [ngClass]="tableClass">

  <thead pgs-st-thead *ngIf="!isHideHeader || !isHideSubHeader"
                      [grid]="grid"
                      [isAllSelected]="isAllSelected"
                      [source]="source"
                      [createConfirm]="createConfirm"
                      (create)="create.emit($event)"
                      (selectAllRows)="onSelectAllRows($event)"
                      (sort)="sort($event)"
                      (filter)="filter($event)">
  </thead>

  <tbody pgs-st-tbody [grid]="grid"
                      [source]="source"
                      [deleteConfirm]="deleteConfirm"
                      [editConfirm]="editConfirm"
                      [rowClassFunction]="rowClassFunction"
                      (edit)="edit.emit($event)"
                      (delete)="delete.emit($event)"
                      (custom)="custom.emit($event)"
                      (userSelectRow)="onUserSelectRow($event)"
                      (editRowSelect)="editRowSelect($event)"
                      (multipleSelectRow)="multipleSelectRow($event)"
                      (rowHover)="onRowHover($event)">
  </tbody>

</table>

<pgs-smart-table-pager *ngIf="isPagerDisplay"
                        [source]="source"
                        [perPageSelect]="perPageSelect"
                        (changePage)="changePage($event)">
</pgs-smart-table-pager>
